module.exports = __webpack_public_path__ + "media/images/email/rewards/redeem_now-2a6f7a7f001e0811e708010604bde86b.png";